import React, { useEffect } from "react";

function DocktPrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      style={{
        backgroundColor: "#ffffff",
        color: "#333333",
        fontFamily: "Arial, sans-serif",
        lineHeight: "1.7",
        padding: "40px 20px",
        minHeight: "100vh",
      }}
    >
      <div
        style={{
          maxWidth: "900px",
          margin: "0 auto",
          background: "#ffffff",
        }}
      >
        <h1 style={{ fontSize: "28px", marginBottom: "20px", color: "#111111" }}>
          Dockt Privacy Policy
        </h1>

        <p style={{ marginBottom: "16px" }}>
          This privacy policy has been compiled to better serve those who are
          concerned with how their 'Personally Identifiable Information' (PII)
          is being used online. PII, as described in US privacy law and
          information security, is information that can be used on its own or
          with other information to identify, contact, or locate a single
          person, or to identify an individual in context. Please read our
          privacy policy carefully to get a clear understanding of how we
          collect, use, protect or otherwise handle your Personally Identifiable
          Information in accordance with our website.
        </p>

        <h3 style={{ fontSize: "18px", marginTop: "24px", marginBottom: "8px", color: "#222222" }}>
          1. What personal information do we collect from the people that download our app?
        </h3>
        <p style={{ marginBottom: "16px" }}>
          When ordering or registering on our app, as appropriate, you may be
          asked to enter your email address, mailing address, phone number or
          other details to help you with your experience.
        </p>

        <h3 style={{ fontSize: "18px", marginTop: "24px", marginBottom: "8px", color: "#222222" }}>
          2. When do we collect information?
        </h3>
        <p style={{ marginBottom: "16px" }}>
          We collect information from you when you register on our app.
        </p>

        <h3 style={{ fontSize: "18px", marginTop: "24px", marginBottom: "8px", color: "#222222" }}>
          3. How do we use your information?
        </h3>
        <p style={{ marginBottom: "12px" }}>
          We may use the information we collect from you when you register, make
          a purchase, sign up for our newsletter, respond to a survey or
          marketing communication, surf the app, or use certain other app
          features in the following ways:
        </p>
        <ul style={{ paddingLeft: "24px", marginBottom: "16px" }}>
          <li style={{ marginBottom: "8px" }}>
            <strong>Camera :</strong> At some points you may have to use our app
            inbuilt camera capture feature for sending us the information
            related to any product or service pertaining to our business with
            you. The feature is entirely based and controlled on your consent
            which unless you chose won't allow us to have any of your data in any
            form received by us.
          </li>
          <li style={{ marginBottom: "8px" }}>
            <strong>Phone state (IMEI no. / UUID) :</strong> At certain points
            we will have to procure your phone's / device's unique identification
            number, which could either be your IMEI number or UUID. The same
            would be used as an authorization towards using the app features.
          </li>
          <li style={{ marginBottom: "8px" }}>
            <strong>Network Information :</strong> Our app is totally internet
            dependent and would not work unless your device has a sufficient data
            speed over the internet, for which we require to determine your
            device's network state
          </li>
          <li style={{ marginBottom: "8px" }}>
            <strong>Location :</strong> In case if our service to you involves a
            location based information sharing then our app may ask you for the
            location information at certain points in order to commence the
            service requested by you, strictly on your consent.
          </li>
          <li style={{ marginBottom: "8px" }}>
            <strong>Media Gallery :</strong> While sending us any information
            in the form of a picture stored in your phone's memory in the
            gallery of images, our app would ask your permission to access the
            same in order to help you select the picture that you wish to upload
            using our app. In no way would our app be able to sneak through the
            information stored inside your media gallery unless you have
            consented.
          </li>
        </ul>

        <h3 style={{ fontSize: "18px", marginTop: "24px", marginBottom: "8px", color: "#222222" }}>
          4. How do we protect your information?
        </h3>
        <p style={{ marginBottom: "16px" }}>
          Our app server is scanned on a regular basis for security holes and
          known vulnerabilities in order to make your visit to our app as safe
          as possible. We use regular Malware Scanning. We do not use an SSL
          certificate We do not need an SSL because we don't have payment
          gateway
        </p>

        <h3 style={{ fontSize: "18px", marginTop: "24px", marginBottom: "8px", color: "#222222" }}>
          5. Do we use 'cookies'?
        </h3>
        <p style={{ marginBottom: "12px" }}>
          We do not use cookies for tracking purposes You can choose to have
          your computer warn you each time a cookie is being sent, or you can
          choose to turn off all cookies. You do this through your browser
          settings. Since browser is a little different, look at your browser's
          Help Menu to learn the correct way to modify your cookies.
        </p>
        <p style={{ marginBottom: "12px" }}>
          If you turn cookies off, some features will be disabled. that make
          your app experience more efficient and may not function properly.
        </p>
        <p style={{ marginBottom: "16px" }}>
          However, you will still be able to place orders .
        </p>

        <hr style={{ margin: "24px 0", borderColor: "#eeeeee" }} />

        <h3 style={{ fontSize: "18px", marginTop: "24px", marginBottom: "8px", color: "#222222" }}>
          Third-party disclosure
        </h3>
        <p style={{ marginBottom: "16px" }}>
          We do not sell, trade, or otherwise transfer to outside parties your
          Personally Identifiable Information.
        </p>

        <h3 style={{ fontSize: "18px", marginTop: "24px", marginBottom: "8px", color: "#222222" }}>
          Third-party links
        </h3>
        <p style={{ marginBottom: "16px" }}>
          We do not include or offer third-party products or services on our
          website.
        </p>

        <h3 style={{ fontSize: "18px", marginTop: "24px", marginBottom: "8px", color: "#222222" }}>
          Google
        </h3>
        <p style={{ marginBottom: "16px" }}>
          Google's advertising requirements can be summed up by Google's
          Advertising Principles. They are put in place to provide a positive
          experience for users.{" "}
          <a
            href="https://support.google.com/adwordspolicy/answer/1316548?hl=en"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#0066cc" }}
          >
            https://support.google.com/adwordspolicy/answer/1316548?hl=en
          </a>{" "}
          We have not enabled Google AdSense on our site but we may do so in the
          future.
        </p>

        <h3 style={{ fontSize: "18px", marginTop: "24px", marginBottom: "8px", color: "#222222" }}>
          California Online Privacy Protection Act
        </h3>
        <p style={{ marginBottom: "16px" }}>
          CalOPPA is the first state law in the nation to require commercial
          websites and online services to post a privacy policy. The law's reach
          stretches well beyond California to require any person or company in
          the United States (and conceivably the world) that operates websites
          collecting Personally Identifiable Information from California
          consumers to post a conspicuous privacy policy on its website stating
          exactly the information being collected and those individuals or
          companies with whom it is being shared. - See more at:{" "}
          <a
            href="http://consumercal.org/california-online-privacy-protection-act-caloppa/#sthash.0FdRbT51.dpuf"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#0066cc" }}
          >
            http://consumercal.org/california-online-privacy-protection-act-caloppa/#sthash.0FdRbT51.dpuf
          </a>
        </p>

        <p style={{ marginBottom: "12px" }}>
          According to CalOPPA, we agree to the following:
        </p>
        <p style={{ marginBottom: "12px" }}>
          Users can visit our site anonymously. Once this privacy policy is
          created, we will add a link to it on our home page or as a minimum,
          on the first significant page after entering our website.
        </p>
        <p style={{ marginBottom: "12px" }}>
          Our Privacy Policy link includes the word 'Privacy' and can easily be
          found on the page specified above.
        </p>
        <p style={{ marginBottom: "12px" }}>
          You will be notified of any Privacy Policy changes Via Email
        </p>
        <p style={{ marginBottom: "16px" }}>
          Can change your personal information By logging in to your account
        </p>

        <h4 style={{ fontSize: "16px", marginTop: "20px", marginBottom: "8px", color: "#222222" }}>
          How does our site handle Do Not Track signals?
        </h4>
        <p style={{ marginBottom: "16px" }}>
          We honor Do Not Track signals and Do Not Track, plant cookies, or use
          advertising when a Do Not Track (DNT) browser mechanism is in place.
        </p>

        <h4 style={{ fontSize: "16px", marginTop: "20px", marginBottom: "8px", color: "#222222" }}>
          Does our site allow third-party behavioral tracking?
        </h4>
        <p style={{ marginBottom: "16px" }}>
          It's also important to note that we do not allow third-party behavioral
          tracking
        </p>

        <h3 style={{ fontSize: "18px", marginTop: "24px", marginBottom: "8px", color: "#222222" }}>
          COPPA (Children Online Privacy Protection Act)
        </h3>
        <p style={{ marginBottom: "16px" }}>
          When it comes to the collection of personal information from children
          under the age of 13 years old, the Children's Online Privacy
          Protection Act (COPPA) puts parents in control. The Federal Trade
          Commission, United States' consumer protection agency, enforces the
          COPPA Rule, which spells out what operators of websites and online
          services must do to protect children's privacy and safety online.
        </p>
        <p style={{ marginBottom: "16px" }}>
          We do not specifically market to children under the age of 13 years
          old.
        </p>

        <h3 style={{ fontSize: "18px", marginTop: "24px", marginBottom: "8px", color: "#222222" }}>
          Fair Information Practices
        </h3>
        <p style={{ marginBottom: "12px" }}>
          The Fair Information Practices Principles form the backbone of privacy
          law in the United States and the concepts they include have played a
          significant role in the development of data protection laws around the
          globe. Understanding the Fair Information Practice Principles and how
          they should be implemented is critical to comply with the various
          privacy laws that protect personal information.
        </p>
        <p style={{ marginBottom: "12px" }}>
          In order to be in line with Fair Information Practices we will take the
          following responsive action, should a data breach occur:
        </p>
        <ul style={{ paddingLeft: "24px", marginBottom: "16px" }}>
          <li style={{ marginBottom: "8px" }}>
            We will notify you via email Within 7 business days
          </li>
          <li style={{ marginBottom: "8px" }}>
            We will notify the users via in-site notification
          </li>
        </ul>
        <p style={{ marginBottom: "16px" }}>
          We also agree to the Individual Redress Principle which requires that
          individuals have the right to legally pursue enforceable rights
          against data collectors and processors who fail to adhere to the law.
          This principle requires not only that individuals have enforceable
          rights against data users, but also that individuals have recourse to
          courts or government agencies to investigate and/or prosecute
          non-compliance by data processors.
        </p>

        <h3 style={{ fontSize: "18px", marginTop: "24px", marginBottom: "8px", color: "#222222" }}>
          CAN SPAM Act
        </h3>
        <p style={{ marginBottom: "12px" }}>
          The CAN-SPAM Act is a law that sets the rules for commercial email,
          estributes requirements for commercial messages, gives recipients the
          right to have emails stopped from being sent to them, and spells out
          tough penalties for violations.
        </p>
        <p style={{ marginBottom: "12px" }}>
          We collect your email address in order to Send information, respond to
          inquiries, and/or other requests or questions
        </p>
        <p style={{ marginBottom: "12px" }}>
          To be in accordance with CANSPAM, we agree to the following :
        </p>
        <ul style={{ paddingLeft: "24px", marginBottom: "12px" }}>
          <li style={{ marginBottom: "8px" }}>
            Not use false or misleading subjects or email addresses.
          </li>
        </ul>
        <p style={{ marginBottom: "16px" }}>
          If at any time you would like to unsubscribe from receiving future
          emails, you can email us at{" "}
          <a href="mailto:connect@dwebbox.com" style={{ color: "#0066cc" }}>
            connect@dwebbox.com
          </a>{" "}
          and we will promptly remove you from ALL correspondence.
        </p>

        <h3 style={{ fontSize: "18px", marginTop: "24px", marginBottom: "8px", color: "#222222" }}>
          Contacting Us
        </h3>
        <p style={{ marginBottom: "12px" }}>
          If there are any questions regarding this privacy policy, you may
          contact us using the information below.
        </p>
        <div
          style={{
            paddingLeft: "16px",
            borderLeft: "3px solid #dddddd",
            marginBottom: "24px",
            color: "#444444",
          }}
        >
          <p style={{ margin: "4px 0" }}>Dockt</p>
          <p style={{ margin: "4px 0" }}>
            2nd Floor, Astana Manzil, 28 Sarang St,
          </p>
          <p style={{ margin: "4px 0" }}>Khokha Bazar, Masjid Bandar,</p>
          <p style={{ margin: "4px 0" }}>
            Mumbai - 400003, Maharashtra, India
          </p>
          <p style={{ margin: "4px 0" }}>
            Email :{" "}
            <a href="mailto:connect@dwebbox.com" style={{ color: "#0066cc" }}>
              connect@dwebbox.com
            </a>
          </p>
          <p style={{ margin: "4px 0" }}>Contact No. +918355908308</p>
        </div>

        <p style={{ fontSize: "14px", color: "#777777", marginTop: "24px" }}>
          Last Edited on 06/10/2027
        </p>
      </div>
    </div>
  );
}

export default DocktPrivacyPolicy;
